import { BookingService } from 'src/app/services/booking.service';
import { EventTypeService } from './../../services/event-type.service';
import { EventService } from './../../services/event.service';
import { RessoureGroup } from './../../interfaces/ressoure-group';
import { EventType } from './../../interfaces/event-type';
import { Booking } from './../../interfaces/booking';
import { EmailListService } from 'src/app/services/emaillist.service';
import { NetworkService } from 'src/app/services/network.service';
import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AlertController, LoadingController, ModalController, MenuController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { Observable, timer } from 'rxjs';
import { Company } from 'src/app/interfaces/company'
import { Location } from 'src/app/interfaces/location'
import { LocationService } from 'src/app/services/location.service';
import { ToastService } from 'src/app/services/toast.service';
import { CompanyService } from 'src/app/services/company.service';
import { Router } from '@angular/router';
import { Scheduler, LocaleManager, EventModel, StringHelper, MessageDialog, ResourceModel, DomHelper, Toolbar, Store, DomClassList, ViewPreset, PresetManager } from '@bryntum/scheduler/scheduler.lite.umd.js';
import { OwnEvent } from 'src/app/interfaces/own-event';
import { tap } from 'rxjs/operators';
import * as moment from 'moment';
import { MessageType } from 'src/app/enums/message-type';
import { WebSocketService } from 'src/app/services/web-socket.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';

// TODO: rene_rowHeight Schedule
// TODO: rene_colLength Schedule mit Gerhard besprechen
// TODO: rene_leftColumnRessource Linke Spalte
// TODO: rene_widthEditTermin 
// TODO: rene_EDITAPPOINTMENT Felder im Editiermodus 
// TODO: rene_Tooltip_Feld
// TODO: rene_EventClick Gerhard fragen
// TODO: 
// TODO: 
// TODO: 


LocaleManager.applyLocale("De")

@Component({
  selector: 'app-schedule',
  templateUrl: './scheduler.component.html',
  styleUrls: ['scheduler.component.scss']
})

export class SchedulerComponent implements OnInit {
  showWsConnectionIndicator: boolean = true
  websocketBookingConnected: boolean = false;
  websocketEventConnected: boolean = false;

  noteChanged: boolean = false;
  //back button values
  progress: any[] = [];
  scheduleEdited: any;
  progressLimit: number = 10;
  scheduler_step = "1w"

  taglist: any[] = []
  viewdate: any;
  bookings: any[] = [];
  employees: Location[] = [];
  services: EventType[] = [];
  filteredEmployees: Location[];
  groups: any[] = [];
  selectedDate: Date = moment().toDate();
  timezone: string;
  // scheduleStates = this.scheduleService.scheduleStates;
  startup: boolean = true;
  possibleStates: any[] = [];
  searchText: string;
  currentLocale: any;
  selectedEvent: any;
  everyTime: Observable<number> = timer(0, 300000);
  ressourceGroups: RessoureGroup[] = [];
  //companyType: string;
  company: Company;
  lang: string;
  loader: any
  //BRYNTUM SCHEDULER
  startDate = moment(new Date()).set("hours", 7).set("minutes", 0).toDate();
  endDate = moment(new Date()).set("hours", 22).set("minutes", 0).toDate();
  currentDate: Date = this.startDate;
  //resourceTimeRanges: any[] = []
  allowOverlap: boolean = false;
  dropAccepted: boolean = false;
  draggedEvent: HTMLElement;
  draggedEventInnerHTML: string;
  rowHeight: number = 40;
  barMargin: number = 3;
  eventStyle: string = "colored"; // border, colored
  tags: any
  useInitialAnimation = "zoom-in"
  hideAnimation: boolean = true;
  enableEventAnimations: boolean = false;
  public field: Object = {};
  private mailing_list: any[] = [];
  public statusFields = { text: 'title', value: 'code' };
  public scheduler: Scheduler;
  private initialZoom: any
  public attendees = []; // for attendee list (right side)
  cellTooltipFeature = {
    hoverDelay: 2000,
    tooltipRenderer: (r) => {
      var tttext;
      return tttext;
    }
  }

  //Toolbar vom Scheduler
  tbar: any[] = [];

  eventStore = {
    modelClass: Event
  }
  token: any;
  //tags: any[];

  constructor(
    public companyservice: CompanyService,
    public locationService: LocationService,
    public translate: TranslateService,
    public loadingCtrl: LoadingController,
    public modalController: ModalController,
    private eventService: EventService,
    private storage: Storage,
    public toastService: ToastService,
    private networkService: NetworkService,
    public alertController: AlertController,
    public router: Router,
    private emailListService: EmailListService,
    private menuCtrl: MenuController,
    private eventTypeService: EventTypeService,
    private webSocketService: WebSocketService,
    private authService: AuthService,
    private bookingService: BookingService
  ) {
    if (this.showWsConnectionIndicator) {
      this.webSocketService.websocketConnectedBooking.subscribe(res => {
        this.websocketBookingConnected = res;
      })
      this.webSocketService.websocketConnectedEvent.subscribe(res => {
        this.websocketEventConnected = res;
      })
    }
  }

  async ngOnInit() {
    this.translate.use("de");
    // DomHelper.setTheme('Stockholm');

    this.lang = await this.storage.get(environment.storage.language);
    let prog = await this.storage.get(environment.storage.progress);
    if (prog != null) {
      this.progress = prog;
    }

    if (this.lang != null) {
      this.translate.use(this.lang);
    }

    this.viewdate = await this.storage.get(environment.storage.viewdate);

    if (this.viewdate !== null) {
      this.selectedDate = this.viewdate;
      this.storage.remove(environment.storage.viewdate);
    }

    // Loader
    this.loader = await this.loadingCtrl.create({
      message: 'Bitte warten...',
      cssClass: 'loading-text'
    });
    this.currentLocale = this.translate.currentLang;

    this.networkService.onNetworkChange().subscribe(async res => {
      if (res === 0) {
        // this.loader = await this.loadingCtrl.create({
        //   message: 'Bitte warten...',
        //   cssClass: 'loading-text'
        // });
        // if (this.startup) {
        //   this.loader.present();
        // }



        // if (this.startup) {
        //   this.loader.dismiss();
        // }

        // this.startup = false;
        //BRYNTUM getAppointment by Company
        this.token = await this.authService.getDecodedUserToken();
        this.companyservice.getCompanyById(this.token.company).subscribe(async companyvar => {
          //this.companyType = companyvar.category.name;
          this.company = companyvar;
          this.allowOverlap = this.company.appointment_overlapping; // if overlapping is enabled
          //this.companyType = companyvar.category.name;
          this.company = companyvar;
          this.tags = this.company.tags;

          this.storage.set(environment.storage.tags, this.company.tags);
          //await this.storage.set('companyType', this.companyType);
          // await this.storage.set('company', this.company);

          this.timezone = 'Europe/Vienna';
          this.services = await this.eventTypeService.getEventTypesOfCompany(this.token.company).toPromise()
          this.storage.set(environment.storage.services, this.services);
          this.locationService
            .getLocations(this.token.company)
            .pipe(
              tap(async employees => {
                try {
                  let data = await this.emailListService.getEmailListFromCompany(this.token.company)
                  this.mailing_list = [];
                  let id = 0;
                  for (let i = 0; i < data.length; i++) {

                    for (let k = 0; k < data[i].emails.length; k++) {
                      id++;
                      this.mailing_list.push({ id: id, name: data[i].emails[k], group: data[i].name });
                    }
                  }
                  console.log("MAILING LIST: ", this.mailing_list)
                }
                catch (error) {
                  console.log("ERROR GETTING EMAIL LIST: ", error)
                }
                this.filteredEmployees = employees;
                this.createScheduler();
                for (let i = 0; i < this.filteredEmployees.length; i++) {
                  this.filteredEmployees[i].id = this.filteredEmployees[i]._id
                }
                // const resource = this.filteredEmployees[0] as unknown as ResourceModel
                this.scheduler.resourceStore.removeAll();
                this.scheduler.resourceStore.add(this.filteredEmployees)
                this.bookings = [];
                const subjectBooking = this.webSocketService.createWebSocketBooking(this.token.company);
                this.webSocketService.websocketConnectedBooking.next(true)
                subjectBooking.subscribe(msg => {
                  switch (msg.type) {
                    case MessageType.INITIAL:
                      this.bookings.push(msg.booking);
                      break;
                    case MessageType.END_OF_INITIAL:
                      console.log('All booking received');
                      this.storage.set(environment.storage.allSchedules, this.bookings);
                      break;
                    case MessageType.INSERT:
                      console.log('Add booking name: ' + msg.booking.name);
                      this.bookings.push(msg.booking);
                      this.storage.set(environment.storage.allSchedules, this.bookings);
                      break;
                    case MessageType.REPLACE:
                      const entryChanged = this.bookings.find(booking => booking._id === msg.booking._id);
                      if (entryChanged !== undefined) {
                        const indexChanged = this.bookings.indexOf(entryChanged);
                        if (indexChanged > -1) {
                          this.bookings[indexChanged] = msg.booking;

                          console.log('Modified booking: ' + msg.booking.name);
                          this.storage.set(environment.storage.allSchedules, this.bookings);
                        } else {
                          console.log('Modified booking in bookings not found ID: ' + msg.booking._id);
                        }
                      } else {
                        console.log('Modified booking not found ID: ' + msg.booking._id);
                      }
                      break;
                    case MessageType.DELETE:
                      let entryDel = this.bookings.find(booking => booking._id === msg.booking._id);
                      if (entryDel !== undefined) {
                        let index = this.bookings.indexOf(entryDel);

                        if (index > -1) {
                          console.log('Booking has been deleted: ' + entryDel.name);
                          this.bookings.splice(index, 1);
                        } else {
                          console.log('Booking to delete not found in bookings ID: ' + msg.booking._id);
                        }
                      } else {
                        console.log('Booking to delete not found ID: ' + msg.booking._id);
                      }
                      break;
                    default:
                      console.log('Unknown message id: ' + msg.type);
                      break;
                  }
                })

                function pingBooking() {
                  return new Promise<void>((resolve) => setTimeout(function () {
                    subjectBooking.next("ping booking")
                    resolve();
                  }, 20000))
                }

                (async () => {
                  while (true) {
                    // console.log("ping Websocket from stefan")
                    await pingBooking()
                  }
                })();

                const subjectEvent = this.webSocketService.createWebSocketEvent(this.token.company)
                this.webSocketService.websocketConnectedEvent.next(true)
                subjectEvent.subscribe(async msg => {
                  switch (msg.type) {
                    case MessageType.INITIAL:
                      this.scheduler.eventStore.add(this.refactorCalendarData(msg.event));
                      break;
                    case MessageType.END_OF_INITIAL:
                      console.log('All events received');
                      break;
                    case MessageType.INSERT:
                      console.log('Event has been addee: ' + msg.event.name);
                      this.scheduler.eventStore.add(this.refactorCalendarData(msg.event));
                      break;
                    case MessageType.REPLACE:
                      const record = this.scheduler.eventStore.findRecord('_id', msg.event._id, true);
                      if (record !== undefined) {
                        Object.assign(record, this.refactorCalendarData(msg.event));
                      } else {
                        console.log('Modified event record not found ID: ' + msg.event._id);
                      }
                      break;
                    case MessageType.DELETE:
                      const recordDel = this.scheduler.eventStore.findRecord('_id', msg.event._id, true) as EventModel;

                      if (recordDel !== undefined) {
                        this.scheduler.eventStore.remove(recordDel);
                      } else {
                        console.log('Event record to delete not found ID: ' + msg.event._id);
                      }
                      break;
                    default:
                      console.log('Unknown message id: ' + msg.type);
                      break;
                  }
                });

                function pingEvent() {
                  return new Promise<void>((resolve) => setTimeout(function () {
                    subjectEvent.next("ping")
                    resolve();
                  }, 20000))
                }
                (async () => {
                  while (true) {
                    // console.log("ping Websocket from stefan")
                    await pingEvent()
                  }
                })();
              })
            )
            .subscribe();
        });
      } else {
        this.bookings = await this.storage.get(environment.storage.allSchedules)
      }
    });
  }

  // schedules appointment termin STYLE
  eventRenderer({ eventRecord, renderData }) {
    let startEndMarkers = ''
    let status = renderData.eventRecord.data.status


    let taghtml = ``;
    if (eventRecord.tags) {
      eventRecord.tags.forEach(t => {
        //tags.push(t.color);
        taghtml += `<p class="b-sch-event-header" style="background-color:${t.color}; width:7px; height:7px; border-radius:50%; margin:3px"></p>`
      })
    }
    if (eventRecord.schedules) {
      if (eventRecord.schedules.length === eventRecord.attendees) {
        renderData.eventColor = "red"
      }
      return `<section>
      <table >
      <td> 
      <div style="font-weight:600">
      <ion-label>${eventRecord.schedules.length} / ${eventRecord.attendees}</ion-label>&nbsp<ion-label  style="float:right">${eventRecord.name}</ion-label>
      </div>
      <div>
      ${moment(eventRecord.startDate).format("HH:mm")} - ${moment(eventRecord.endDate).format("HH:mm")}
      </div>
      </td> 
      <td>
        <div style="display: flex; flex-wrap: wrap;margin-left:10px">` +
        taghtml +
        `</div>
          </td>
        </table>
      </section>`
    }
    else {
      return `<section>
      <table>
        <td>
          <div class="b-sch-event-header">${moment(eventRecord.startDate).format("HH:mm")} - ${moment(eventRecord.endDate).format("HH:mm")}</div>
          <div class="b-sch-event-header">${eventRecord.name}</div>
        </td> <td><div style="display: flex; flex-wrap: wrap;margin-left:10px">` +
        taghtml +
        `</div></td></table>
      </section>`
    }

  }

  updateAttendeesList(attendee) {
    let attendees = attendee;
    if (attendees.length === 0) {
      attendees = [{ email: "--- NOCH KEINE TEILNEHMER ---" }]
    }
    return attendees
  }

  async deleteAttendee(attendee, i) {
    const alert = await this.alertController.create({
      header: "Entfernen des Teilnehmers",
      message: "Möchten Sie diesen Teilnehmer wirklich entfernen?",
      buttons: [
        {
          text: "Abbrechen",
          role: 'cancel'
        },
        {
          text: "OK",
          role: 'ok',
          handler: () => {
            this.attendees.splice(i, 1);
            this.selectedEvent.schedules = this.attendees.map(a => a._id);
            const eventToNotify = { ...this.selectedEvent }
            console.log("SELECTED EVENT: ", this.selectedEvent);

            this.eventService.editEvent(this.selectedEvent).subscribe(x => {
              this.bookingService.deleteBooking(attendee._id).subscribe(res => {
                this.eventService.notifyCustomerDeletedBooking(attendee.email, eventToNotify).subscribe(async res => {
                  console.log("SUCCESS: ", res);
                  this.toastService.showToast("success", attendee.email + " wurde erfolgreich benachrichtigt")
                }, err => {
                  this.toastService.showToast("danger", "FEHLER!" + attendee.email + " wurde nicht benachrichtigt. Führen Sie dies bitte manuell durch");
                })
                console.log("booking removed: ", res)
              }, err => {
                console.log("error booking removed: ", err)
              })
              console.log(x);
            }, err => {
              console.log(err);
            })
          }
        }
      ]
    });
    await alert.present();
  }

  private createScheduler() {
    const myViewPreset = new ViewPreset({
      id: 'myPreset',// Unique id value provided to recognize your view preset. Not required, but having it you can simply set new view preset by id: scheduler.viewPreset = 'myPreset'
      // Eindeutiger ID-Wert zur Erkennung der Voreinstellung der Ansicht. Nicht erforderlich, aber wenn Sie sie haben, können Sie einfach eine neue Ansichtsvoreinstellung mit der ID festlegen: scheduler.viewPreset = 'myPreset'
      name: 'My view preset',        // A human-readable name provided to be used in GUI, e.i. preset picker, etc.

      tickWidth: 24,                // Time column width in horizontal mode
      tickHeight: 50,                // Time column height in vertical mode
      displayDateFormat: 'DD.MM HH:mm',    // Controls how dates will be displayed in tooltips etc

      shiftIncrement: 1,             // Controls how much time to skip when calling shiftNext and shiftPrevious.
      shiftUnit: 'week',         // Valid values are 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'.
      defaultSpan: 1,            // By default, if no end date is supplied to a view it will show 12 hours

      timeResolution: {              // Dates will be snapped to this resolution
        unit: 'hour',       // Valid values are 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'.
        increment: 1
      },

      headers: [                     // This defines your header rows from top to bottom
        {                           // For each row you can define 'unit', 'increment', 'dateFormat', 'renderer', 'align', and 'thisObj'
          unit: 'week',
          dateFormat: "{KW} W MMMM'YY"
        },
        {
          unit: 'day',

          dateFormat: 'dd DD.MM'
        },
        {
          unit: 'hour',
          increment: 12,
          dateFormat: 'HH:mm'
        }
      ],

      columnLinesFor: 1              // Defines header level column lines will be drawn for. Defaults to the last level.
    });
    PresetManager.add(myViewPreset);

    console.log("CREATE SCHEDULER")
    // console.log("filtered employees:", this.filteredEmployees)

    //Create base scheduler
    this.scheduler = new Scheduler({
      appendTo: "scheduler",
      enableEventAnimations: false,
      zoomOnMouseWheel: false,
      zoomOnTimeAxisDoubleClick: false,
      resources: [{ id: "1", fullname: "Location werden geladen..." }],
      viewPreset: 'myPreset',
      mode: "horizontal",
      eventStyle: this.eventStyle,
      cls: "scheduler",
      rowHeight: 100,
      barMargin: 1,
      eventStore: {
        modelClass: Event
      },

      hideAnimation: false,
      useInitialAnimation: "zoom-in",

      allowOverlap: this.allowOverlap,
      eventRenderer: this.eventRenderer,
      multiEventSelect: true,
      responsiveLevels: {
        small: {
          levelWidth: 800,
          tickSize: 10,
          fillTicks: true,
          rowHeight: 50,
          barMargin: 2
        },
        normal: {
          levelWidth: '*',
          tickSize: 80,// rene_colLength
          fillTicks: true,
          rowHeight: 60,// rene_rowHeight
          barMargin: 2
        }
      },
      // minHeight: 1000,
      columns: {

        responsiveLevels: {
          small: { width: 50, minWidth: 50 },
          normal: { width: 100 }
        },
        data: [
          { text: "LOCATION", field: 'fullname', width: 180, editor: false }, // rene_leftColumnRessource
          // { text: "Teilenhmer", field: 'email', width: 100, editor: false },
        ],
      },

      features: {
        rowCopyPaste: {
          disabled: true,
        },
        eventResize: {
          disabled: true
        },
        stripe: true,
        resourceTimeRanges: true,
        timeRanges: {
          showCurrentTimeLine: true,
          enableResizing: true,
          showHeaderElements: true,
          tooltipTemplate: ({ timeRange }) => timeRange.name
        },
        //grouping
        // group: "ressource_group.title",
        //Event editor

        eventEdit: {
          editorConfig: {
            autoClose: true,
            width: '30em',// rene_widthEditTermin
            modal: true,
            bbar: {
              items: {
                cancelButton:
                {
                  onAction: (event) => {
                    //this.scheduler.events = [];
                    //this.scheduler.events = this.events
                  }
                }
              }
            },
          },

          // rene_EDITAPPOINTMENT Add items to the event editor
          items: {
            resourceField: {
              hidden: true,
            },
            noteField: {
              type: "text",
              name: "note",
              weight: 650,
              label: this.translate.instant("note")
            },
            seatsField: {
              type: 'number',
              name: 'seats',
              label: this.translate.instant("newapp.person"),
              weight: 120,
              required: true,
              min: 1,
            },
            serviceField: {
              type: 'combo',
              label: 'Service',
              name: 'services',
              editable: true,
              weight: 140,
              required: true,
              multiSelect: false,
              listItemTpl: item => `<div>${item.text}</div>`,
              items: this.services.map(service => [service._id, service.name + " (" + service.duration + " min)"]),
              onChange: ({ value }) => {
                this.setCorrectTimes(value);
                
              }
            },

            durationField: {
              type: 'text',
              disabled: true,
              label: "Dauer",
              weight: 620
            },

            endDateField: {
              disabled: true,
              onChange: ({ value }) => {
                // this.setCorrectTimes(value);
                this.scheduler.features.eventEdit.endDateField = value;
                // const start = moment(this.scheduler.features.eventEdit.startDateField.value).set("hours", moment(this.scheduler.features.eventEdit.startTimeField.value).get("hours")).set("minutes", moment(this.scheduler.features.eventEdit.startTimeField.value).get("minutes"))
                // const end = moment(this.scheduler.features.eventEdit.endDateField.value).set("hours", moment(this.scheduler.features.eventEdit.endTimeField.value).get("hours")).set("minutes", moment(this.scheduler.features.eventEdit.endTimeField.value).get("minutes"))
                // const duration_final = end.diff(start, "minutes")
                // this.scheduler.features.eventEdit["durationField"].value = this.checkTime(duration_final)
              }
            },

            endTimeField: {
              disabled: true,
              onChange: ({ value }) => {
                //this.setCorrectTimes(value);
                this.scheduler.features.eventEdit.endDateField = value;
                // const start = moment(this.scheduler.features.eventEdit.startDateField.value).set("hours", moment(this.scheduler.features.eventEdit.startTimeField.value).get("hours")).set("minutes", moment(this.scheduler.features.eventEdit.startTimeField.value).get("minutes"))
                // const end = moment(this.scheduler.features.eventEdit.endDateField.value).set("hours", moment(this.scheduler.features.eventEdit.endTimeField.value).get("hours")).set("minutes", moment(this.scheduler.features.eventEdit.endTimeField.value).get("minutes"))
                // const duration_final = end.diff(start, "minutes")
                // this.scheduler.features.eventEdit["durationField"].value = this.checkTime(duration_final)
              }
            },

            startDateField: {
              onChange: ({ value }) => {
                //this.setCorrectTimes(value);
                let duration = moment(this.scheduler.features.eventEdit.endDateField).diff(this.scheduler.features.eventEdit.startDateField, "minutes");
                this.scheduler.features.eventEdit.startDateField = value;
                //let duration = this.scheduler.features.eventEdit["durationField"].value;
                this.scheduler.features.eventEdit.endDateField.value = moment(this.scheduler.features.eventEdit.startDateField.value).add(duration, "minutes").toDate();
                this.scheduler.features.eventEdit.endTimeField.value = moment(this.scheduler.features.eventEdit.startTimeField.value).add(duration, "minutes").toDate();
                //const start = moment(this.scheduler.features.eventEdit.startDateField.value).set("hours", moment(this.scheduler.features.eventEdit.startTimeField.value).get("hours")).set("minutes", moment(this.scheduler.features.eventEdit.startTimeField.value).get("minutes"))
                //const end = moment(this.scheduler.features.eventEdit.endDateField.value).set("hours", moment(this.scheduler.features.eventEdit.endTimeField.value).get("hours")).set("minutes", moment(this.scheduler.features.eventEdit.endTimeField.value).get("minutes"))
                //const duration_final = end.diff(start, "minutes")
                //this.scheduler.features.eventEdit["durationField"].value = this.checkTime(duration_final)
              }
            },
            startTimeField: {
              onChange: ({ value }) => {
                //this.setCorrectTimes(value);
                let duration = moment(this.scheduler.features.eventEdit.endDateField).diff(this.scheduler.features.eventEdit.startDateField, "minutes");
                this.scheduler.features.eventEdit.startDateField = value;
                //let duration = this.scheduler.features.eventEdit["durationField"].value;
                //this.scheduler.features.eventEdit.endDateField.value = moment(value).add(duration, "minutes").toDate();
                this.scheduler.features.eventEdit.endDateField.value = moment(this.scheduler.features.eventEdit.startDateField.value).add(duration, "minutes").toDate();
                this.scheduler.features.eventEdit.endTimeField.value = moment(this.scheduler.features.eventEdit.startTimeField.value).add(duration, "minutes").toDate();
                //this.scheduler.features.eventEdit.endTimeField.value = moment(this.scheduler.features.eventEdit.startTimeField.value).add("minutes", duration).toDate();
                //const start = moment(this.scheduler.features.eventEdit.startDateField.value).set("hours", moment(this.scheduler.features.eventEdit.startTimeField.value).get("hours")).set("minutes", moment(this.scheduler.features.eventEdit.startTimeField.value).get("minutes"));
                //const end = moment(this.scheduler.features.eventEdit.endDateField.value).set("hours", moment(this.scheduler.features.eventEdit.endTimeField.value).get("hours")).set("minutes", moment(this.scheduler.features.eventEdit.endTimeField.value).get("minutes"));
                //const end = 
                //const duration_final = end.diff(start, "minutes")
                //this.scheduler.features.eventEdit["durationField"].value = this.checkTime(duration)
              }
            }
            // openField: {
            //   label: 'Offen für alle',
            //   type: 'toggle',
            //   toggleable: true,
            //   onChange: ({ value }) => { console.log(value) },
            //   weight: 143
            // },
            // emailListField: {
            //   type: 'combo',
            //   label: 'Emails',
            //   name: 'emaillist',
            //   displayField: 'name',
            //   valueField: 'name',
            //   editable: true,
            //   multiSelect: true,
            //   // items: this.mailing_list.map(list => [list._id, list.name]),
            //   picker: {
            //     allowGroupSelect: true,
            //     // Show icon based on group name
            //     groupHeaderTpl: (record, groupName) => `
            //         ${groupName}
            //     `
            //   },
            //   store: new Store({
            //     fields: [
            //       'group'
            //     ],
            //     groupers: [
            //       { field: 'group', ascending: true }
            //     ],
            //     data:
            //       this.mailing_list
            //   }),
            //   weight: 145
            // },
            //   tagsField: {
            //     type: 'combo',
            //     label: 'Tags',
            //     name: 'tags',
            //     editable: true,
            //     multiSelect: true,
            //     weight: 150,
            //     listItemTpl: item => `<span style="
            //     height: 15px;
            //     margin-right:5px;
            // width: 15px;
            // background-color: ${item.value};
            // border-radius: 50%;
            // display: inline-block;">
            // </span><div>${item.text}</div>`,
            //     items: this.company.tags.map(tag => [tag.color, tag.title]),
            //     chipView: {
            //       iconTpl: record => `<span style="
            //             height: 15px;
            //             margin-right:5px;
            //         width: 15px;
            //         background-color: ${record.value};
            //         border-radius: 50%;
            //         display: inline-block;">
            //         </span>`,

            //     }
            //   }
          }
        },
        // rene_Tooltip_Feld Tooltip
        eventTooltip: {
          header: false,

          template: data => {
            console.log("TOOLTIP DATA: ", data)
            // let htmlPhone = ``;
            let htmlName = ``;
            let htmlAttendees = ``;
            let htmlTime = ``;
            // let htmlTags = ``;
            // let htmlCat = ``;
            // let htmlNote = ``;
            // let htmlSeats = ``;
            // let htmlStatus = ``;
            //let tags = [];
            // let htmlRecurrence = ``;
            // data.eventRecord.tags?.forEach(t => {
            //   this.tags.push(t.title);
            // })
            let sl: any[] = data.eventRecord.data.schedules;
            if (data.eventRecord.data.name != undefined && data.eventRecord.data.name != "") {
              htmlName += `<tr><td> ${data.eventRecord.data.name}</td></tr>`
              console.log(data.eventRecord.data);
            }
            if (data.eventRecord.data.attendees != undefined && data.eventRecord.data.attendees != "") {
              htmlAttendees += `<tr><td><ion-icon name="people-outline"></ion-icon>  ${sl.length} / ${data.eventRecord.attendees} </td></tr>`
            }
            if (data.eventRecord.startDate != undefined && data.eventRecord.endDate != undefined) {
              htmlTime += `<tr><td><ion-icon name="time-outline"></ion-icon> ${moment(data.eventRecord.startDate).locale('de').format("dddd HH:mm")} - ${moment(data.eventRecord.endDate).locale('de').format("dddd HH:mm")}</td></tr>`
            }
            // if (data.eventRecord.data.schedules.lenght > 0) {
            //   htmlSchedules += `<tr><td><ion-icon name="people-outline"></ion-icon> ${data.eventRecord.schedules.lenght}</td></tr>`
            // }

            // if (data.eventRecord.note != undefined && data.eventRecord.note != "") {
            //   htmlNote += `<tr><td><ion-icon name="document-outline"></ion-icon> ${data.eventRecord.note}</td></tr>`
            // }
            // if (data.eventRecord.phone != "") {
            //   htmlPhone += `<tr><td><ion-icon name="call-outline"></ion-icon> ${data.eventRecord.phone}</td></tr>`
            // }
            // if (data.eventRecord.seats != undefined && data.eventRecord.seats != "") {
            //   htmlSeats += `<tr><td><ion-icon name="people-outline"></ion-icon> ${data.eventRecord.seats}</td></tr>`
            // }
            // if (data.eventRecord.category != undefined && data.eventRecord.category != "") {
            //   htmlCat += `<tr><td><ion-icon name="restaurant-outline"></ion-icon> ${data.eventRecord.category} : ${this.getNameOfService(data.eventRecord.services[0])}</td></tr>`
            // }
            // if (data.eventRecord.tags != undefined && data.eventRecord.tags != "") {
            //   htmlTags += `<tr><td><ion-icon name="pricetags-outline"></ion-icon> ${this.tags}</td></tr>`
            // }
            // if (data.eventRecord.data.recurrence_rule != undefined) {
            //   htmlRecurrence += `<ion-icon name="sync-outline"></ion-icon> ${this.getRruleString(data.eventRecord.data.recurrence_rule)}`
            // }
            // gemacht am 16.12.2021
            // neu am 12.05.2022
            // todo ausgabe
            return `<section>
        <table>
        <th>
        `+ htmlName + `
        </th>
        <td>
        `+ htmlAttendees + `
        </td>
          `+ htmlTime + `
        </table>
      </section>
      `
          },
        },
        // hoverDelay: 1500,
        // header: {
        //   titleAlign: 'start'
        // },
        // onBeforeShow({ source: tooltip }) {
        //   // tooltip.title = StringHelper.encodeHtml(tooltip.eventRecord.name);
        //   tooltip.title = `<h3> <ion-icon name="finger-print-outline"></ion-icon> ${tooltip.eventRecord.name}</h3>`
        // },
        // // tools: [

        // //   {
        // //     cls: 'b-fa b-fa-trash',
        // //     handler: (eventRecord) => {
        // //       console.log("EVENT: ", eventRecord)
        // //     }
        // //   },
        // //   {
        // //     cls: 'b-fa b-fa-edit',
        // //     handler: function () {
        // //       this.eventRecord.remove();
        // //       this.hide();
        // //     }
        // //   },
        // // ],
        //   template: data => {
        //     //let tags = [];
        //     console.log("DAT: ", data)
        //     if (this.taglist == undefined || this.taglist.length == 0) {
        //       if (data.eventRecord.tags) {
        //         data.eventRecord.tags.forEach(t => {
        //           this.taglist.push(t.title);
        //         });
        //       }
        //     }
        //     // console.log("DATA: ", data)
        //     if (data.eventRecord.services != undefined) {
        //       // TODO: Tooltip
        //       return `<div><dl>
        //         <dt> <ion-icon name="time-outline"></ion-icon> ${moment(data.eventRecord.startDate).format("HH:mm")} - ${moment(data.eventRecord.endDate).format("HH:mm")}</dt>
        //         // <dt> <ion-icon name="call-outline"></ion-icon> ${data.eventRecord.phone}</dt>
        //         <dt> <ion-icon name="people-outline"></ion-icon>${data.eventRecord.schedules.length}/${data.eventRecord.attendees} gebucht</dt>
        //         <dt> <ion-icon name="restaurant-outline"></ion-icon> ${data.eventRecord.category} : ${this.getNameOfService(data.eventRecord.services[0])}</dt>
        //         <dt> <ion-icon name="document-outline"></ion-icon> ${data.eventRecord.note}</dt>
        //         <dt> <ion-icon name="pricetags-outline"></ion-icon> ${this.taglist}</dt>
        //       </dl></div>`
        //     }
        //     else if (data.eventRecord.phone == undefined) {

        //       // <dt> <ion-icon name="call-outline"></ion-icon> ${data.eventRecord.phone}</dt>
        //       return `<div><dl>
        //         <dt> <ion-icon name="time-outline"></ion-icon> ${moment(data.eventRecord.startDate).format("HH:mm")} - ${moment(data.eventRecord.endDate).format("HH:mm")}</dt>
        //         <dt> <ion-icon name="people-outline"></ion-icon>${data.eventRecord.schedules.length}/${data.eventRecord.attendees} gebucht</dt>
        //         <dt> <ion-icon name="clipboard-outline"></ion-icon>${this.getNameOfService(data.eventRecord.service)}</dt>
        //         <dt *ngIf="data.eventRecord.note"> <ion-icon name="document-outline"></ion-icon> ${data.eventRecord.note}</dt>
        //       </dl></div>`
        //     }
        //   }
        // },


        // cellTooltip: {
        //   hoverDelay: 2000,
        //   tooltipRenderer: function (r) {
        //     var tttext;
        //     return tttext;
        //   }
        // },
        eventDrag: {
          validatorFn(event) {
            // console.log(event)
            let available = true;
            let message = ""
            // console.log("NEW RESOURCE: ", newResource)
            // console.log("START DATE: ", startDate);
            // console.log("DRAGGED RECORDS: ", draggedRecords)
            // const result: ResourceModel = this.scheduler.resources.find(res => res["data"]._id === newResource.data._id) as ResourceModel
            // console.log("RESULT: ", result)
            if (event.startDate.getTime() > new Date(event.eventRecord.data.end_date).getTime()) {
              available = this.scheduler.isDateRangeAvailable(event.startDate, event.endDate, null, event.newResource)
            }
            // console.log("AVAILABLE: ", available)
            //Drag to new resource...
            if (event.newResource._id != event.resourceRecord._id) {
              // this.scheduler.features.eventDrag.constrainDragToTimeSlot = true
              console.log("EVENT: ", event)
              available = this.scheduler.isDateRangeAvailable(new Date(event.eventRecord.data.start_date), new Date(event.eventRecord.data.end_date), null, event.newResource);
              if (!available) {
                message = "Termin würde anderen Termin überlappen!"
              }
              else {
                message = ""
              }
            }
            return {
              valid: available,
              message: message
            };
          },

          tooltipTemplate: (event) => {
            if (event.message == "") {
              return `<div>${moment(event.startDate).format("HH:mm")} - ${moment(event.endDate).format("HH:mm")}</div>`
            }
            if (event.message == "Zur Reservierungsliste hinzufügen") {
              return `<div>${event.message}</div>`
            }
            return `
            <div style="display:flex;flex-direction:column;">
              <div>${moment(event.startDate).format("HH:mm")} - ${moment(event.endDate).format("HH:mm")}</div>
              <div style="color:red"> <ion-icon name="warning-outline"></ion-icon>${event.message} </div>
            </div>`
          },
          constrainDragToTimeline: false,
          externalDropTargetSelector: '.treeview-container'
        },
        cellMenu: {
          items: {
            cut: false,
            removeRow: false,
            copy: false
          }
        },
        //Rechtsklick Menü
        eventMenu: {
          items: {
            // Add extra items shown for each event
            // setState: {
            //   text: this.translate.instant("schedule.set_state"),
            //   icon: 'b-fa b-fa-fw b-fa-arrows-alt-h',
            //   cls: 'b-separator',
            //   weight: 100,
            //   // Add submenu
            //   menu: {
            //   }
            // },
            // Edit a built in item
            deleteEvent: {
              weight: 150
            },
            cutEvent: false,
            copyEvent: false
          },
        },
        // groupSummary : {
        //   target:"header",
        //   collapseToHeader : true,
        //   summaries        : [
        //       // {
        //       //     label : 'Full time',

        //       //     renderer : ({ events }) => {
        //       //       console.log("EVENTS: ", events)
        //       //         // Only count events for resources that are "Full time"
        //       //         return events.length;
        //       //     }
        //       // },
        //       {
        //         label : 'Total',
        //         height : 40, // needed to make summary row grow correctly
        //         renderer({ events }) {
        //             const value = Math.min(1, events.length / 5),
        //                 height = (100 * value) + '%';
        //             return `
        //                <div class="bar-outer">
        //                    <div class="bar-inner" style="height: ${height}"><label class="${value > 0.5 ? 'b-summarybar-label-inside' : ''}">${events.length || ''}</label></div>
        //                </div>
        //             `;
        //         }
        //     }
        //   ]
        // },
        // summary: {
        //   showTooltip: true,
        //   renderer: ({ startDate, endDate, events }) => {
        //     this.setAppointmentsToday();
        //     // console.log("CURRENT DATE: ", this.currentDate)
        //     // console.log("SUMMARY RENDERER: ", this.appointmentsToday)
        //     if (events.length > 0) {
        //       let total: number = 0;

        //       //TODO HARDCODED LIMIT
        //       let limit = 70
        //       let firstStep = 0.25;
        //       let secondStep = 0.5;
        //       let thirdStep = 0.75
        //       let percent = total / limit;
        //       let color = 'white';
        //       if (percent > firstStep && percent < secondStep) {
        //         color = '#ffffe0';
        //       } else if (percent > secondStep && percent < thirdStep) {
        //         color = '#fed8b1';
        //       } else if (percent > thirdStep) {
        //         color = '#ffcccb';
        //       }
        //       if (total > 0) {
        //         return `
        //         <div style="background-color: ${color}; ">
        //           <ion-icon name="person"></ion-icon> ${total}
        //         </div>`
        //       }
        //       else {
        //         return `<div></div>`
        //       }
        //     }
        //     return `<div></div>`
        //   }
        // },
      }
    });


    this.setupStartAndEndScheduler(new Date(), "week");
    this.setupSchedulerToolbar();

    //Add Handlers..
    this.scheduler.onResourceHeaderContextmenu = (event) => {
      console.log(event)
      event.items = [];
    }
    this.scheduler.onAfterEventSave = (event) => {
      console.log("AftereventSave: ", event);
      if (event.eventRecord.data._id == undefined) {
        this.scheduler.eventStore.remove(event.eventRecord)
      }

    }
    // rene_EventClick 
    this.scheduler.onEventClick = (event) => {
      this.selectedEvent = event.eventRecord.data;
      this.attendees = this.updateAttendeesList(this.bookings.filter(app => app.event === event.eventRecord.data._id));
      this.eventTypeService.getService(event.eventRecord.data.service).subscribe(service => {
        this.locationService.getLocationById(event.eventRecord.data.location).subscribe(location => {
          this.selectedEvent.location = location;
          this.selectedEvent.service = service;
        }, err => {

        })
      }, err => {

      })

    }

    // this.scheduler.onHeaderMenuBeforeShow = (event) => {
    //   console.log(event);
    // }
    this.scheduler.onEventSelectionChange = (event) => {
      if (event.selection.length === 0) {
        this.attendees = [];
      }
    }

    this.scheduler.onBeforeEventDropFinalize = (event) => {
      this.beforeDropFinalize(event);
    }

    this.scheduler.onRenderEvent = (event) => {

    }

    this.scheduler.onBeforeEventEditShow = (event) => {



      event.editor._widgetMap.serviceField.items = this.services.map(service => {
        const d = Math.floor(service.duration * 60 / (3600 * 24));
        const h = Math.floor(service.duration * 60 % (3600 * 24) / 3600);
        const m = Math.floor(service.duration * 60 % 3600 / 60);
        if (d > 0) {
          return [service._id, service.name + " (" + d + "d " + h + "h " + m + "m)"]
        }
        else {
          if (h > 0) {
            return [service._id, service.name + " (" + h + "h " + m + "m)"]
          }
          else {
            return [service._id, service.name + " (" + m + "m)"]
          }
        }
      });
      // event.editor._widgetMap.emailListField.store = new Store({
      //   fields: [
      //     'group'
      //   ],
      //   groupers: [
      //     { field: 'group', ascending: true }
      //   ],
      //   data:
      //     this.mailing_list
      // })
      event.editor._widgetMap.noteField.value = event.eventRecord.data.note;
      event.editor._widgetMap.seatsField.value = event.eventRecord.data.attendees;
      const duration = moment(event.eventRecord.data.endDate).diff(moment(event.eventRecord.data.startDate), "minutes")
      event.editor._widgetMap.durationField.value = this.checkTime(duration)
      // console.log("DURATION: ", duration)

      if (event.eventRecord.data.service) {
        if (typeof event.eventRecord.data.service === "string") {
          event.editor._widgetMap.serviceField.value = event.eventRecord.data.service;
        }
        else {
          event.editor._widgetMap.serviceField.value = event.eventRecord.data.service._id;
        }
      }


      //event.editor._widgetMap.emailListField.value = event.eventRecord.data.mailing_list;
    }



    this.scheduler.onCellMouseOver = (event) => {
      //If Event is being dragged from reservation list
      if (this.scheduleEdited != null) {
        //If not on room
        if (event.record.data._id != undefined) {
          const result: ResourceModel = this.scheduler.resources.find(res => res["data"]._id === event.record.data._id) as ResourceModel
          let available = this.scheduler.isDateRangeAvailable(new Date(this.scheduleEdited.start_date), new Date(this.scheduleEdited.end_Date), null, result)
          this.draggedEvent.style.backgroundColor = available ? "rgba(0,0,0,0.507" : "rgba(255,0,0,0.507"
          // if (!available) {
          //   this.draggedEvent.innerHTML = this.draggedEventInnerHTML + "<span>NOT ALLOWED</span>"
          // }
          // else {
          //   this.draggedEvent.innerHTML = this.draggedEventInnerHTML
          // }
        }
        //If on room
        else {
          this.draggedEvent.style.backgroundColor = "rgba(255,0,0,0.507"
        }
      }
    }

    this.scheduler.onBeforeRenderRows = (event) => {

    }

    this.scheduler.onBeforeEventDelete = async (event) => {
      console.log("EVENT: ", event)

      this.attendees = this.updateAttendeesList(this.bookings.filter(app => app.event === event.eventRecords[0].data._id))

      //If attendees are to be notified that event is cancelled.....




      const result = await MessageDialog.confirm({
        title: this.translate.instant("schedule.dialog.deletecontent"),
        message: this.translate.instant("schedule.dialog.deleteheader"),
        okButton: this.translate.instant("schedule.dialog.yes"),
        cancelButton: this.translate.instant("schedule.dialog.no"),
      });
      if (result == 1) {
        if (typeof event.eventRecords[0].data.service === "string") {


          this.eventTypeService.getService(event.eventRecords[0].data.service).subscribe(service => {
            event.eventRecords[0].data.service = service;
            if (this.attendees.length > 0 && this.attendees[0].email != "--- NOCH KEINE TEILNEHMER ---") {
              this.eventService.notifyCustomersCancelledEvent(this.attendees, event.eventRecords[0].data).subscribe(async res => {
                console.log("RES: ", res);
                this.toastService.showToast('success', "Teilnehmer wurden erfolgreich benachrichtigt");
                this.eventService.deleteEvent(event.eventRecords[0].data._id).subscribe(async res => {
                  this.attendees = []
                }, err => {
                })
              }, err => {
                console.log("ERR: ", err);
              })
            }
            else {
              console.log("delete event");
              this.eventService.deleteEvent(event.eventRecords[0].data._id).subscribe(async res => {
                this.attendees = []
              }, err => {
              })
            }

          })
        }

        else {
          console.log("else")
          if (this.attendees.length > 0 && this.attendees[0].email != "--- NOCH KEINE TEILNEHMER ---") {
            this.eventService.notifyCustomersCancelledEvent(this.attendees, event.eventRecords[0].data).subscribe(async res => {
              this.toastService.showToast('success', "Teilnehmer wurden erfolgreich benachrichtigt");
              console.log("delete event");
              this.eventService.deleteEvent(event.eventRecords[0].data._id).subscribe(async res => {
                this.attendees = []
              }, err => {
              })
              console.log("RES: ", res);
            }, err => {
              console.log("ERR: ", err);
            })
          }
          else {
            console.log("delete event");
            this.eventService.deleteEvent(event.eventRecords[0].data._id).subscribe(async res => {
              this.attendees = []
            }, err => {
            })
          }
        }
      }
    }

    this.scheduler.onBeforeEventSave = (event) => {
      this.eventSaved(event);
    }

    this.scheduler.onEventMenuBeforeShow = (event) => {
      this.beforeEventMenu(event);
    }

    this.scheduler.onEventDrop = (event) => {
      const eventToSave = event.eventRecords[0].data
      const oldEvent = { ...event.eventRecords[0].data }
      eventToSave.start_date = event.eventRecords[0]._startDate
      eventToSave.end_date = event.eventRecords[0]._endDate
      eventToSave.location = event.targetResourceRecord.data._id

      // console.log(eventToSave)
      // await this.updateSchedule(appToSave);
      // await this.updateProgress(event.eventRecords[0].originalData);
      this.dropAccepted = true;

      this.eventService.editEvent(eventToSave).toPromise();

      console.log("LOCATION: ", eventToSave.location)
      eventToSave.location = event.targetResourceRecord.data
      this.eventTypeService.getService(eventToSave.service).subscribe(service => {
        eventToSave.service = service;
        oldEvent.service = service;
        console.log("LOCATION: ", eventToSave.location)
        const attendees = this.updateAttendeesList(this.bookings.filter(app => app.event === event.eventRecords[0].data._id))
        this.selectedEvent = event.eventRecords[0].data

        if (attendees.length > 0 && attendees[0].email != "--- NOCH KEINE TEILNEHMER ---") {
          console.log("notify attendees")
          this.eventService.notifyCustomersChangedEvent(oldEvent, eventToSave, attendees).subscribe(res => {
            this.toastService.showToast("success", "Teilnehmer wurden erfolgreich benachrichtigt!")
          }, err => {
            this.toastService.showToast("danger", "FEHLER! Teilnehmer wurden nicht benachrichtigt. Bitte führen Sie dies manuell durch.")
          })
        }
      });
    }

    this.scheduler.onEventResizeEnd = async (event) => {
      if (event.changed) {
        let eventToEdit = { ...event.eventRecord.data }
        // NEEDED FOR WINTER TIME!!!!!!!!
        // let offset = new Date(event.eventRecord.startDate).getTimezoneOffset();
        // let start = moment(new Date(event.eventRecord.startDate)).add(offset, "minutes").toDate();
        // let end = moment(new Date(event.eventRecord.endDate)).add(offset, "minutes").toDate();
        eventToEdit.start_date = new Date(event.eventRecord.startDate);
        eventToEdit.end_date = new Date(event.eventRecord.endDate);
        // console.log("EVENT TO EDIT: ", eventToEdit)
        this.eventService.editEvent(eventToEdit).subscribe(res => {
          console.log("event edited");
        }, err => {
          console.log("ERROR on event resize: ", err);
        })
        // await this.updateProgress(event.eventRecord.originalData);
      }
    }

    /*this.scheduler.eventStore.onBeforeRemove = (event) => {
      /*if (event.records[0].remove == true) {
        return true;
      }

      return false;
    }*/
  }
  setCorrectTimes(value) {
    let service = this.services.find(ser => ser._id === value);
    if (service != undefined) {
      let duration = service.duration;
      console.log("service change")
      console.log("duration: ", duration)
      this.scheduler.features.eventEdit.endDateField.value = moment(this.scheduler.features.eventEdit.startDateField.value).add(duration, "minutes").toDate();
      this.scheduler.features.eventEdit.endTimeField.value = moment(this.scheduler.features.eventEdit.startTimeField.value).add(duration, "minutes").toDate();
      // this.scheduler.features.eventEdit.endDateField.value = moment(this.scheduler.features.eventEdit.startDateField.value).add("minutes", duration).toDate();
      // this.scheduler.features.eventEdit.endTimeField.value = moment(this.scheduler.features.eventEdit.startTimeField.value).add("minutes", duration).toDate();
      const start = moment(this.scheduler.features.eventEdit.startDateField.value).set("hours", moment(this.scheduler.features.eventEdit.startTimeField.value).get("hours")).set("minutes", moment(this.scheduler.features.eventEdit.startTimeField.value).get("minutes"))
      const end = moment(this.scheduler.features.eventEdit.endDateField.value).set("hours", moment(this.scheduler.features.eventEdit.endTimeField.value).get("hours")).set("minutes", moment(this.scheduler.features.eventEdit.endTimeField.value).get("minutes"))
      const duration_final = end.diff(start, "minutes")
      this.scheduler.features.eventEdit["durationField"].value = this.checkTime(duration_final)
    }
  }

  // Scheduler Functions
  setupStartAndEndScheduler(date: Date, unit) {
    if (unit === "day") {

      this.scheduler.startDate = moment(date).set("hours", 0).toDate();
      this.scheduler.endDate = moment(date).set("hours", 24).toDate();
    }
    if (unit == "week") {
      console.log("WEEKDAY: ", moment(date).weekday())
      if (this.scheduler.tbar) {
        this.scheduler.tbar.items[1].value = moment(date).subtract("days", moment(date).weekday() - 1).toDate()
      }

      this.scheduler.startDate = moment(date).subtract("days", moment(date).weekday() - 1).toDate();
      this.scheduler.endDate = moment(this.scheduler.startDate).add("days", 7).toDate();
      console.log("START: ", this.scheduler.startDate);
      console.log("END: ", this.scheduler.endDate);
    }
  }

  checkTime(minDuration) {
    const d = Math.floor(minDuration * 60 / (3600 * 24));
    const h = Math.floor(minDuration * 60 % (3600 * 24) / 3600);
    const m = Math.floor(minDuration * 60 % 3600 / 60);
    if (d > 0) {
      if (d === 1) {
        return d + " Tag " + h + " Stunden " + m + " Minuten"
      }
      else {
        return d + " Tage " + h + " Stunden " + m + " Minuten"
      }

    }
    else {
      if (h > 0) {
        if (h === 1 && m > 0) {
          return h + " Stunde " + m + " Minuten"
        }
        if (h === 1 && m == 0) {
          return h + " Stunde "
        }
        else {
          if (m > 0) {
            return h + " Stunden " + m + " Minuten"
          }
          else {
            return h + " Stunden "
          }
        }
      }
      else {
        return m + " Minuten"
      }


    }
  }

  private setupSchedulerToolbar() {
    this.initialZoom = this.scheduler.zoomLevel;
    this.scheduler.tbar = new Toolbar({
      appendTo: document.body,
      height: '3em',
      items: [
        {
          type: 'button',
          text: "Menü",
          onAction: ({ value }) => {
            this.menuCtrl.open()
          }
        },
        {
          type: 'button',
          // text: 'Wizard',
          icon: 'b-fa-magic',
          tooltip: 'Start Wizard-Event',
          onAction: () => {
            // this.router.navigate(['appointment-wiz']).then(() => { });
            this.router.navigate(['self/wizard-event']).then(() => { });
          }
        },
        {
          type: 'button',
          // text: 'Wizard',
          icon: 'b-fa-wrench',
          tooltip: 'zu den Einstellungen',
          onAction: () => {
            // this.router.navigate(['appointment-wiz']).then(() => { });
            this.router.navigate(['folder/Einstellungen']).then(() => { });
          }
        },
        {
          type: 'slidetoggle',
          text: 'Wochenansicht',
          checked: this.scheduler_step === "1d" ? false : true,
          onAction: async (value) => {

            if (value.value == true) {
              this.scheduler_step = "1w"
              this.scheduler.viewPreset = "myPreset"
              this.scheduler.maxZoomLevel = this.scheduler.zoomLevel
              this.scheduler.minZoomLevel = this.scheduler.zoomLevel
              this.scheduler.tbar.items[4]._step = { magnitude: 1, unit: "week" }
              this.setupStartAndEndScheduler(this.scheduler.startDate, "week");
            }
            else {
              this.scheduler_step = "1d"


              this.scheduler.viewPreset = "hourAndDay"
              this.scheduler.tbar.items[4]._step = { magnitude: 1, unit: "day" }
              this.setupStartAndEndScheduler(this.scheduler.startDate, "day");
            }
          }
        },
        {
          type: 'date',
          value: this.scheduler.startDate,
          step: this.scheduler_step,
          onChange: ({ value }) => {
            if (this.scheduler_step === "1d") {
              console.log("DAY")
              this.setupStartAndEndScheduler(value, "day");
            }
            if (this.scheduler_step === "1w") {
              this.setupStartAndEndScheduler(value, "week");
            }
          }
        },
        // {
        //   type: 'textfield',
        //   ref: 'highlight',
        //   placeholder: 'Events hervorheben',
        //   clearable: true,
        //   keyStrokeChangeDelay: 100,
        //   triggers: {
        //     filter: {
        //       align: 'start',
        //       cls: 'b-fa b-fa-search'
        //     }
        //   },
        //   onChange: ({ value }) => {
        //     this.scheduler.eventStore.forEach(task => {
        //       const taskClassList = new DomClassList(task.cls);
        //       console.log(taskClassList)
        //       if (value !== '' && task.data.name.toLowerCase().includes(value.toLowerCase())) {
        //         taskClassList.add('b-match');

        //       }
        //       else {
        //         taskClassList.remove('b-match');
        //       }
        //       task.cls = taskClassList.value;
        //     });

        //     this.scheduler.element.classList[value.length > 0 ? 'add' : 'remove']('b-highlighting');
        //   }
        // },

        // {
        //   type: 'button',
        //   text: 'Zusammenfassung',
        //   toggleable: true,
        //   icon: 'b-fa-table',
        //   onToggle: ({ pressed }) => {
        //     this.scheduler.features.summary.disabled = !pressed;
        //   }
        // },

        // {
        //   type: 'button',
        //   text: 'Demo',
        //   tooltip: 'Return to initial view',
        //   onAction: async () => {
        //     this.loader = await this.loadingCtrl.create({
        //       message: 'Demodaten werden generiert...',
        //       cssClass: 'loading-text'
        //     });
        //     this.loader.present();
        //     let appointments: Appointment[] = [];



        //     for (let i = 0; i < this.filteredEmployees.length; i++) {
        //       for (let k = 0; k < this.groups.length; k++) {
        //         await this.sleep(150)
        //         console.log(".")

        //         let appointment: Appointment = getEmptyAppointment();
        //         appointment.company = this.companyId;
        //         appointment.employee = this.filteredEmployees[i]._id;

        //         let hours: number = parseInt(this.groups[k].start_date.split(':')[0]);
        //         // console.log("HOURS ",hours)
        //         let startdate = moment(this.scheduler.startDate).set("hours", hours).set("minutes", 0).set("seconds", 0).toDate();
        //         // startdate.setHours(hours);
        //         let endDate = moment(startdate).add(2, "hour").toDate();

        //         appointment.start_date = startdate
        //         appointment.end_date = endDate
        //         appointment.name = "Demodaten";
        //         appointment.seats = 2;
        //         appointment.id = new Date().getTime().toString() + Math.floor(Math.random() * 100000).toString() + Math.floor(Math.random() * 100000).toString() + Math.floor(Math.random() * 100000).toString();

        //         // GUID NOT WORKING BECAUSE ID SHOULD ONLY CONSIST OF NUMBERS!!!
        //         // appointment.id=Guid.create().toString();
        //         // console.log("GUID: ", appointment.id)
        //         // console.log("GROUPS: ", this.groups);
        //         console.log("SERVICES: ", this.services);
        //         let service;
        //         for (let i = 0; i < this.services.length; i++) {
        //           if (this.services[i].service_group._id == this.groups[k]._id) {
        //             service = this.services[i];
        //             break;
        //           }
        //           // console.log("FOUND SERVICE: ", this.services[i])
        //         }
        //         if (service) {
        //           appointment.services = [];
        //           appointment.services.push(service._id);
        //           //appointment.services[0]=service._id;
        //         }
        //         appointments.push(appointment);
        //       }
        //     }
        //     // console.log("LENGTH: ", appointments.length)
        //     appointments.forEach(app => {
        //       // console.log("START: ",app.start_date);
        //       // console.log("END: ",app.end_date);
        //       this.scheduleService.addAppointment(this.companyId, this.companyType, app).toPromise();
        //     })
        //     this.loader.dismiss();
        //   }
        // },

      ]
    })
  }

  //BRYNTUM
  eventSaved(event) {
    console.log("saving: ", event);
    console.log(this.scheduler.events);

    if (event.eventRecord.data._id) {
      const eventToSave: OwnEvent = {
        start_date: event.values.startDate,
        end_date: event.values.endDate,
        location: event.resourceRecords[0].data._id,
        service: event.values.services,
        mailing_list: event.values.emaillist,
        attendees: event.values.seats,
        schedules: this.scheduler.events.find(ev => ev["data"]._id === event.eventRecord.data._id)["data"].schedules,
        name: event.values.name,
        company: this.token.company,
        note: event.values.note,
        _id: event.eventRecord.data._id
      }
      console.log("EVENT TO SAVE: ", eventToSave)
      this.eventService.editEvent(eventToSave).subscribe(res => {
        console.log("Event edited: ", res);
        // this.toastService.showToast("success", "Einladungen wurden erfolgreich versendet!")
        //TODO Email notification
        // eventToSave.service = this.services.find(s => s._id === eventToSave.service).name;
        // eventToSave.place = { name: event.resourceRecords[0].data.fullname, street: event.resourceRecords[0].data.street, zipcode: event.resourceRecords[0].data.zipcode, city: event.resourceRecords[0].data.city }
        // this.scheduleService.notifyCustomers(eventToSave).then(res => {
        //   this.toastService.showToast("success", "Einladungen wurden erfolgreich versendet!")
        // }).catch(err => {
        //   console.log("ERROR ON NOTIFYING CUSTOMERS: ", err);
        // })
      }, err => {
        console.log("ERROR ON EDIT EVENT ", err);
      });
    } else {
      const eventToSave: OwnEvent = {
        start_date: event.values.startDate,
        end_date: event.values.endDate,
        location: event.resourceRecords[0].data._id,
        service: event.values.services,
        mailing_list: event.values.emaillist,
        attendees: event.values.seats,
        schedules: [],
        name: event.values.name,
        company: this.token.company,
        note: event.values.note
      }
      this.eventService.addEvent(eventToSave).subscribe(res => {
        console.log("Event added: ", res);
        // this.toastService.showToast("success", "Einladungen wurden erfolgreich versendet!")
        //TODO Email notification
        // eventToSave.service = this.services.find(s => s._id === eventToSave.service).name;
        // eventToSave.place = { name: event.resourceRecords[0].data.fullname, street: event.resourceRecords[0].data.street, zipcode: event.resourceRecords[0].data.zipcode, city: event.resourceRecords[0].data.city }
        // this.scheduleService.notifyCustomers(eventToSave).then(res => {
        //   this.toastService.showToast("success", "Einladungen wurden erfolgreich versendet!")
        // }).catch(err => {
        //   console.log("ERROR ON NOTIFYING CUSTOMERS: ", err);
        // })
      }, err => {
        console.log("ERROR ON ADD EVENT ", err);
      })
    }
  }

  refactorCalendarData(booking: any) {
    booking.resourceId = booking.location;
    booking.startDate = moment(booking.start_date).add(new Date().getTimezoneOffset(), "minutes").toDate();
    booking.endDate = moment(booking.end_date).add(new Date().getTimezoneOffset(), "minutes").toDate();

    return booking
  }

  async beforeDropFinalize({ context }) {
    context.async = true;
    let finalize: boolean = false;
    const result = await MessageDialog.confirm({
      title: this.translate.instant("schedule.dialog.header"),
      message: this.translate.instant("schedule.dialog.content"),
      okButton: this.translate.instant("schedule.dialog.yes"),
      cancelButton: this.translate.instant("schedule.dialog.no"),
    });
    if (result == 1) {
      finalize = true;



    }
    await context.finalize(finalize);
  }

  // dataChange(event) {
  //   console.log("DATA CHANGED: ", event)
  // }

  // eventAdd(event) {
  //   console.log("Before event add: ", event)
  // }

  // getServiceGroupNameOfService(serviceId: string) {
  //   for (let i = 0; i < this.services.length; i++) {
  //     if (this.services[i]._id == serviceId) {
  //       return this.services[i].service_group.name + ' ';
  //     }
  //   }
  // }

  getNameOfService(serviceId: string) {
    for (let i = 0; i < this.services.length; i++) {
      if (this.services[i]._id == serviceId) {
        return this.services[i].name + ' ';
      }
    }
  }

  // getStatusName(status: number): string {
  //   let state = scheduleStates.find(state => state.code == status);
  //   return state.title
  // }
  // generatePossibleStates(code: number, data: any): any[] {
  //   let arr: any[] = [];
  //   for (let i = 0; i < scheduleStates.length; i++) {
  //     if (scheduleStates[i].code > code) {
  //       if (scheduleStates[i].code == 200) {
  //         let dateNow = new Date();
  //         let di = (dateNow.getTime() - data.startDate.getTime()) / 1000 / 60;
  //         //If difference from start to now > 15
  //         if (di > 15) {
  //           arr.push(scheduleStates[i]);
  //           break;
  //         }
  //       } else if (scheduleStates[i].code == 100) {
  //         let dateNow = new Date();
  //         let di = (data.startDate.getTime() - dateNow.getTime()) / 1000 / 60;
  //         //If difference from start to now > 15
  //         if (di <= 30) {
  //           arr.push(scheduleStates[i]);
  //           break;
  //         }
  //       } else {
  //         arr.push(scheduleStates[i]);
  //         break;
  //       }
  //     }
  //   }
  //   for (let i = scheduleStates.length - 1; i >= 0; i--) {
  //     if (scheduleStates[i].code < code) {
  //       arr.push(scheduleStates[i]);
  //       break;
  //     }
  //   }
  //   return arr;
  // }

  async deleteEventLocal(id: string) {
    let index;
    for (let i = 0; i < this.bookings.length; i++) {
      if (this.bookings[i]._id == id) {
        index = i;
        break;
      }
    }

    if (index != undefined) {
      this.bookings.splice(index, 1);

      this.storage.set(environment.storage.allSchedules, this.bookings);
    }
  }

  async updateProgress(data) {
    if (this.progress.length <= this.progressLimit) {
      this.progress.unshift(data);
    } else {
      this.progress.pop();
      this.progress.unshift(data);
    }
    this.storage.set(environment.storage.progress, this.progress);
  }

  //Auswählbare Status generieren
  //Rechtsklick menü
  beforeEventMenu(event) {
    event.items.deleteEvent.onItem = async (event) => {

      this.attendees = this.updateAttendeesList(this.bookings.filter(app => app.event === event.eventRecord.data._id))

      //If attendees are to be notified that event is cancelled.....

      const result = await MessageDialog.confirm({
        title: this.translate.instant("schedule.dialog.deletecontent"),
        message: this.translate.instant("schedule.dialog.deleteheader"),
        okButton: this.translate.instant("schedule.dialog.yes"),
        cancelButton: this.translate.instant("schedule.dialog.no"),
      });
      if (result == 1) {
        if (typeof event.eventRecord.data.service === "string") {


          this.eventTypeService.getService(event.eventRecord.data.service).subscribe(service => {
            event.eventRecord.data.service = service;
            if (this.attendees.length > 0 && this.attendees[0].email != "--- NOCH KEINE TEILNEHMER ---") {
              this.eventService.notifyCustomersCancelledEvent(this.attendees, event.eventRecord.data).subscribe(async res => {
                console.log("RES: ", res);
                this.toastService.showToast('success', "Teilnehmer wurden erfolgreich benachrichtigt");
                this.eventService.deleteEvent(event.eventRecord.data._id).subscribe(async res => {
                  this.attendees = []
                }, err => {
                })
              }, err => {
                console.log("ERR: ", err);
              })
            }
            else {
              console.log("delete event");
              this.eventService.deleteEvent(event.eventRecord.data._id).subscribe(async res => {
                this.attendees = []
              }, err => {
              })
            }

          })
        }

        else {
          console.log("else")
          if (this.attendees.length > 0 && this.attendees[0].email != "--- NOCH KEINE TEILNEHMER ---") {
            this.eventService.notifyCustomersCancelledEvent(this.attendees, event.eventRecord.data).subscribe(async res => {
              this.toastService.showToast('success', "Teilnehmer wurden erfolgreich benachrichtigt");
              console.log("delete event");
              this.eventService.deleteEvent(event.eventRecord.data._id).subscribe(async res => {
                this.attendees = []
              }, err => {
              })
              console.log("RES: ", res);
            }, err => {
              console.log("ERR: ", err);
            })
          }
          else {
            console.log("delete event");
            this.eventService.deleteEvent(event.eventRecord.data._id).subscribe(async res => {
              this.attendees = []
            }, err => {
            })
          }
        }
      }
    }
    let appointment = event.eventRecord.data;
    // let states = this.generatePossibleStates(appointment.status, appointment);

    // event.items.backToRes = {
    //   text: this.translate.instant("schedule.to_reservation"),
    //   icon: 'b-fa b-fa-fw b-fa-arrow-right',
    //   cls: 'b-separator',
    //   weight: 511,
    //   onItem: async ({ eventRecord }) => {

    //     // this.updateSchedule(eventRecord.data);
    //     const toProgress = { ...eventRecord.data }
    //     await this.updateProgress(toProgress)
    //     eventRecord.data.employee = null;
    //     eventRecord.data.id = new Date().getTime().toString();
    //     this.eventService.editEvent(eventRecord.data).toPromise();
    //   }
    // }
  }
  //TODO EDITEVENT FUNCTION NOT WORKING
  editInList(apdata) {
    for (let i = 0; i < this.scheduler.events.length; i++) {
      if (this.scheduler.events[i]["data"]._id == apdata._id) {
        let app = this.scheduler.events[i]["data"] as Booking
        let event = new Event();
        console.log("FIELDS: ", event.allFields)
        event.set("startDate", app.start_date)
        event.set("endDate", app.end_date)
        event.set("name", app.name)
        event.set("phone", app.phone)
        event.set("seats", app.seats)
        // event.set("category", )
        event.set("services", app.services)
        event.set("tags", app.tags)
        event.set("status", app.status)
        event.set("note", app.note)
        event.set("_id", app._id)
        this.scheduler.editEvent(event)

        console.log("EDIT EVENT SHOULD FIRE: ", this.scheduler.events[i])
        break;
      }
    }

    console.log(this.scheduler.eventStore.data)
    console.log("EDIT EVENT SHOULD FIRE: ", this.scheduler.events[0])
  }

  async deleteEvent(data) {
    const result = await MessageDialog.confirm({
      title: this.translate.instant("schedule.dialog.deletecontent"),
      message: this.translate.instant("schedule.dialog.deleteheader"),
      okButton: this.translate.instant("schedule.dialog.yes"),
      cancelButton: this.translate.instant("schedule.dialog.no"),
    });
    if (result == 1) {
      console.log("DELETE EVENT: ", data)

      this.eventService.deleteEvent(data._id).subscribe(async res => {
        await this.deleteEventLocal(data._id)
        await this.updateProgress(data)
        this.toastService.showToast('success', this.translate.instant('schedule.deleted'));
      })
    }

    console.log("DELETE EVENT: ", data)
  }

  onPopupOpen(data) {
    console.log("POPUP OPEN: ", data)
  }

  async onTreeDragStop(event) {
    if (event.target._domData != undefined) {
      // console.log("onTreeDragStop");
      let table = this.filteredEmployees.find(emp => emp._id == event.target._domData.id);
      // console.log("DOMDATA: ", event.target._domData);
      // console.log("TARGET TABLE: ", table)
      // console.log("EVENT: ", this.scheduleEdited);

      //Wenn Tisch und kein Raum
      if (table) {
        const result: ResourceModel = this.scheduler.resources.find(res => res["data"]._id === table._id) as ResourceModel
        let available = this.scheduler.isDateRangeAvailable(new Date(this.scheduleEdited.start_date), new Date(this.scheduleEdited.end_Date), null, result)
        if (available) {
          this.scheduleEdited.id = new Date().getTime().toString()
          const toProgress = { ...this.scheduleEdited }
          await this.updateProgress(toProgress)
          this.scheduleEdited.employee = table._id;
          this.eventService.editEvent(this.scheduleEdited).subscribe(res => {
            this.scheduleEdited = null;
          })
        } else {
          this.toastService.showToast('danger', this.translate.instant('schedule.not_vacant'));
        }
      } else {
        this.toastService.showToast('danger', this.translate.instant('schedule.no_employee'));
      }
    }
  }

  // async goBack() {
  //   // console.log('VERLAUF: ', this.progress);
  //   if (this.progress[0] != undefined) {
  //     // console.log("FIRST: ", this.progress[0])
  //     //recurrance
  //     if (Array.isArray(this.progress[0])) {
  //       console.log('IS ARRAY!');
  //       //deleted or not
  //       if (this.appointments.find(app => app._id == this.progress[0][0]._id)) {
  //         console.log('NOT DELETED');
  //         this.progress[0].forEach(async app => {
  //           let data = { ...app };
  //           data.startTime = moment(app.start_date, 'YYYY-MM-DD HH:mm').toDate();
  //           data.endTime = moment(app.end_date, 'YYYY-MM-DD HH:mm').toDate();
  //           // await this.updateSchedule(data);
  //           this.editSchedule(app).toPromise();
  //         });
  //         this.progress.shift();
  //         await this.storage.set('progress', this.progress);
  //       }
  //       //deleted
  //       else {
  //         console.log('DELETED!');
  //         this.progress[0].forEach(async app => {
  //           app.id = new Date().getTime().toString()
  //           let data = { ...app };
  //           data.startTime = moment(app.start_date, 'YYYY-MM-DD HH:mm').toDate();
  //           data.endTime = moment(app.end_date, 'YYYY-MM-DD HH:mm').toDate();
  //           console.log('DATA: ', data);
  //           this.appointments.push(data);
  //           // await this.updateSchedule(data);
  //           // this.addSchedule(app).toPromise();
  //         });
  //         this.progress.shift();
  //         await this.storage.set('progress', this.progress);
  //       }
  //     }
  //     //Single Date
  //     else {
  //       this.progress[0].id = new Date().getTime().toString()
  //       let data = { ...this.progress[0] };
  //       data.startTime = moment(this.progress[0].start_date, 'YYYY-MM-DD HH:mm').toDate();
  //       data.endTime = moment(this.progress[0].end_date, 'YYYY-MM-DD HH:mm').toDate();
  //        await this.updateSchedule(data);
  //       console.log("APPOINTMENTS: ", this.appointments)

  //       //Check if schedule was edited or deleted..
  //       if (this.appointments.find(app => app._id == this.progress[0]._id)) {
  //         this.editSchedule(this.progress[0]).toPromise();

  //         //deleted
  //       } else {
  //         console.log("DELETED")
  //         this.appointments.push(data);

  //         this.addSchedule(this.progress[0]).toPromise();
  //       }
  //       this.progress.shift();
  //       await this.storage.set('progress', this.progress);
  //     }
  //   }
  // }

  getWorkloadColor(count: number) {
    //console.log(date.getDate());
    let percent = count / this.filteredEmployees.length;
    let color = 'white';
    if (percent > 0.25 && percent < 0.5) {
      color = 'green';
    } else if (percent > 0.5 && percent < 0.75) {
      color = '#fed8b1';
    } else if (percent > 0.75) {
      color = '#ffcccb';
    }
    return color;
  }
}

//TODO: Bitte AuthSourcen
//Wird für den Editor gebraucht. Hier werden die Felder im Editor definiert
export class Event extends EventModel {

  static get fields() {
    return [
      { name: '_id', type: 'string' },
      { name: 'id', type: 'number' },
      { name: 'phone', type: 'string' },
      { name: 'resourceId', type: 'string' },
      { name: 'name', type: 'string' },
      { name: 'startDate', type: 'date' },
      { name: 'endDate', type: 'date' },
      { name: "seats", type: "number", defaultValue: 2 },
      { name: "category", type: 'string' },
      { name: "services", type: 'array' },
      { name: "tags", type: 'array' },
      { name: "status", type: 'number' },
      { name: "note", type: "string" }
    ];
  }

}
